// ISO_A3 : [oben, mitte, unten]
export const FLAG_COLORS = {
  AUT: ["#ED2939", "#FFFFFF", "#ED2939"], // Österreich
  DEU: ["#000000", "#DD0000", "#FFCE00"], // Deutschland
  CHE: ["#FF0000", "#FF0000", "#FFFFFF"], // Schweiz (weißes Kreuz simuliert)
  ITA: ["#009246", "#FFFFFF", "#CE2B37"], // Italien
  SVN: ["#FFFFFF", "#0B4EA2", "#D71A28"], // Slowenien
  HUN: ["#CE2939", "#FFFFFF", "#477050"], // Ungarn
  CZE: ["#FFFFFF", "#D7141A", "#11457E"], // Tschechien
  SVK: ["#FFFFFF", "#0B4EA2", "#D71A28"], // Slowakei
  LIE: ["#00209F", "#CE1126", "#FFD700"], // Liechtenstein
  FRA: ["#0055A4", "#FFFFFF", "#EF4135"],
  ESP: ["#AA151B", "#F1BF00", "#AA151B"],
};
